import { observer } from 'mobx-react';
import * as React from 'react';
import { AlreadyTranslatedText } from '../../../../../../../Translations';
import LearningCollectionEditStore from '../../../../Edit/Store';
import { SectionContext } from '../../../../Types';
import Store from '../Store';
import { ExperiencesResource } from '../Types';
import Body from './Body';
import Heading from './Heading';
import SelectingHeader from './SelectingHeader';

interface Props {
  learningCollectionStore: LearningCollectionEditStore;
  learningDesignName: AlreadyTranslatedText;
  experiences: ExperiencesResource;
  store: Store;
  context: SectionContext;
}

const ModalBodySelecting: React.FC<Props> = ({
  learningCollectionStore,
  learningDesignName,
  experiences,
  store,
  context,
}) => (
  <div className="absolute left-0 top-0 z-50 h-full w-full bg-white overflow-y-scroll">
    <SelectingHeader store={store} />
    <Heading
      context={context}
      learningCollectionStore={learningCollectionStore}
      learningDesignName={learningDesignName}
    />
    <Body
      learningCollectionStore={learningCollectionStore}
      experiences={experiences}
      store={store}
      context={context}
    />
  </div>
);

export default observer(ModalBodySelecting);
